export class StorageKeys{
    public static readonly USER_AUTH = 'userData';
    public static readonly USER_PROFILE = 'userProfileData';
    public static readonly FEED_DATA = 'feedData';
}


// WEBPACK FOOTER //
// ./src/config/storage.keys.ts